const LOCATION_TYPES = {
  DISTRIBUTION_CENTER: 'DistributionCenter',
};

export { LOCATION_TYPES };
